var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTicketOutlinedIcon = function SvgTicketOutlinedIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9444 12C19.9444 11.2265 20.2664 10.4846 20.8394 9.93761C21.4124 9.39062 22.1896 9.08333 23 9.08333V6.16667C23 5.85725 22.8712 5.5605 22.642 5.34171C22.4128 5.12292 22.1019 5 21.7778 5H2.22222C1.89807 5 1.58719 5.12292 1.35798 5.34171C1.12877 5.5605 1 5.85725 1 6.16667V9.08333C1.81038 9.08333 2.58758 9.39062 3.1606 9.93761C3.73363 10.4846 4.05556 11.2265 4.05556 12C4.05556 12.7735 3.73363 13.5154 3.1606 14.0624C2.58758 14.6094 1.81038 14.9167 1 14.9167V17.8333C1 18.1428 1.12877 18.4395 1.35798 18.6583C1.58719 18.8771 1.89807 19 2.22222 19H21.7778C22.1019 19 22.4128 18.8771 22.642 18.6583C22.8712 18.4395 23 18.1428 23 17.8333V14.9167C22.1896 14.9167 21.4124 14.6094 20.8394 14.0624C20.2664 13.5154 19.9444 12.7735 19.9444 12Z",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTicketOutlinedIcon);
export default ForwardRef;